var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"940578a29d9aaa3427fa933dca2b779818659061"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["tryup-hp@pluspace"]={id:"940578a29d9aaa3427fa933dca2b779818659061"};
      